export default __webpack_public_path__ + "static/media/F_wdt_c_cap_0.9fc56881.mp3";